import React from "react";
import Header from "@/components/layout/Header";
import MobileActionBar from "@/components/layout/MobileActionBar";
import Hero from "@/components/sections/Hero";
import TrustBar from "@/components/sections/TrustBar";
import Services from "@/components/sections/Services";
import About from "@/components/sections/About";
import Process from "@/components/sections/Process";
import Gallery from "@/components/sections/Gallery";
import BeforeAfter from "@/components/sections/BeforeAfter";
import ResidentialCommercial from "@/components/sections/ResidentialCommercial";
import ServiceArea from "@/components/sections/ServiceArea";
import CTASection from "@/components/sections/CTASection";
import QuoteForm from "@/components/sections/QuoteForm";
import Contact from "@/components/sections/Contact";

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <section id="home">
          <Hero />
        </section>
        <TrustBar />
        <section id="services">
          <Services />
        </section>
        <section id="about">
          <About />
        </section>
        <Process />
        <section id="projects">
          <Gallery />
        </section>
        <BeforeAfter />
        <ResidentialCommercial />
        <section id="service-area">
          <ServiceArea />
        </section>
        <CTASection />
        <section id="quote">
          <QuoteForm />
        </section>
        <section id="contact">
          <Contact />
        </section>
      </main>
      {/* ❌ ELIMINAR Footer de aquí */}
      <div className="h-16 sm:hidden" />
      <MobileActionBar />
    </div>
  );
}